<template>
  <div class="RangeInput">
    <div class="flex justify-between items-center w-full">
      <input
        v-model.number="min"
        type="number"
        :min="minValue"
        :placeholder="`min ${addPlaceholder}`"
        @keyup.enter="submit"
      />
      <span class="block mx-2">to</span>
      <input
        v-model.number="max"
        type="number"
        :min="maxMinValue"
        :placeholder="`max ${addPlaceholder}`"
        @keyup.enter="submit"
      />

      <button @click="submit" class="bg-grey-dark px-8 h-full text-white outline-hidden">&gt;</button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
import reject from "lodash/reject"

export default {
  name: "Side.RangeInput",
  props: {
    addPlaceholder: {
      type: String,
      default: "",
    },
    minValue: {
      type: Number,
    },
    initial: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      min: this.initial[0],
      max: this.initial[1],
    }
  },
  methods: {
    reset() {
      this.min = null
      this.max = null
    },
    submit() {
      const blank = reject([this.min, this.max], (value) => value == "" || value == null)

      blank.length == 0 ? this.clear() : this.set()
      this.$emit("submit")
    },
    clear() {
      this.$emit("clear", "price_range")
    },
    set() {
      const minValue = this.minValue
      const min = parseInt(this.min) || 0
      const max = parseInt(this.max) || 0

      if (minValue && min < minValue) this.min = minValue
      if (parseInt(this.min) > max) this.max = 99999

      this.$emit("set", { price_range: [this.min, this.max] })
    },
  },
  computed: {
    maxMinValue() {
      if (this.min == undefined) return undefined

      return parseInt(this.min) + 1
    },
  },
}
</script>

<style scoped>
@import "@/css/tailwind_theme.css";
@reference "tailwindcss";

input[type="number"],
button {
  height: 40px;
}

input[type="number"] {
  @apply p-4 bg-grey-lighter outline-hidden;
  width: 30%;
}

button {
  outline: none;
}
</style>
